import { call, put, takeEvery } from "redux-saga/effects";

// Calender Redux States
import {
    CREATE_INVENTORY,
    DELETE_INVENTORY,
    GET_INVENTORY_DETAILS,
    GET_INVENTORY_FILTERS,
    GET_INVENTORY_STOCK_STATUSES,
    GET_INVENTORY_LISTING,
    UPDATE_INVENTORY
} from "./actionTypes.js";

import {
    createInventoryFail,
    createInventorySuccess,
    deleteInventoryFail,
    deleteInventorySuccess,
    getInventoryDetailsFail,
    getInventoryDetailsSuccess,
    getInventoryFiltersFail,
    getInventoryFiltersSuccess,
    getInventoryStockStatusesFail,
    getInventoryStockStatusesSuccess,
    getInventoryListingFail,
    getInventoryListingSuccess,
    updateInventoryFail,
    updateInventorySuccess
} from "./actions.js";

import { inventoryCreateApi, inventoryDeleteApi, inventoryDetailsApi, inventoryFiltersApi, inventoryListingApi, inventoryStockStatusesApi, inventoryUpdateApi } from "./inventoryApi.js";

function* fetchInventoryListing({ payload }) {
    try {
        const response = yield call(inventoryListingApi, payload);
        yield put(getInventoryListingSuccess(response));
    } catch (error) {
        yield put(getInventoryListingFail(error));
    }
}

function* fetchInventoryDetails({ payload }) {
    try {
        const response = yield call(inventoryDetailsApi, payload);
        yield put(getInventoryDetailsSuccess(response));
    } catch (error) {
        yield put(getInventoryDetailsFail(error));
    }
}

function* fetchInventoryFilters() {
    try {
        const response = yield call(inventoryFiltersApi);
        yield put(getInventoryFiltersSuccess(response));
    } catch (error) {
        yield put(getInventoryFiltersFail(error));
    }
}

function* fetchInventoryStockStatuses() {
    try {
        const response = yield call(inventoryStockStatusesApi);
        yield put(getInventoryStockStatusesSuccess(response));
    } catch (error) {
        yield put(getInventoryStockStatusesFail(error));
    }
}

function* fetchInventoryCreate({ payload }) {
    try {
        const response = yield call(inventoryCreateApi, payload);
        yield put(createInventorySuccess(response));
    } catch (error) {
        yield put(createInventoryFail(error));
    }
}

function* fetchInventoryUpdate({ payload }) {
    try {
        const response = yield call(inventoryUpdateApi, payload);
        yield put(updateInventorySuccess(response));
    } catch (error) {
        yield put(updateInventoryFail(error));
    }
}

function* fetchInventoryDelete({ payload }) {
    try {
        const response = yield call(inventoryDeleteApi, payload);
        yield put(deleteInventorySuccess(response));
    } catch (error) {
        yield put(deleteInventoryFail(error));
    }
}


function* InventorySaga() {
    yield takeEvery(GET_INVENTORY_LISTING, fetchInventoryListing);
    yield takeEvery(GET_INVENTORY_DETAILS, fetchInventoryDetails);
    yield takeEvery(GET_INVENTORY_FILTERS, fetchInventoryFilters);
    yield takeEvery(GET_INVENTORY_STOCK_STATUSES, fetchInventoryStockStatuses);
    yield takeEvery(CREATE_INVENTORY, fetchInventoryCreate);
    yield takeEvery(UPDATE_INVENTORY, fetchInventoryUpdate);
    yield takeEvery(DELETE_INVENTORY, fetchInventoryDelete);
}

export default InventorySaga
